<template lang="pug">
.form-check.dawn-radio
  label.form-check-label
    input.form-check-input(
      type="radio"
      :name="name"
      :value="optionStatus"
      :checked="optionStatus"
      :id="optionLabel"
      v-bind="$props"
      @click="chooseRadio"
    )
    | {{optionLabel}}
</template>

<script>

import { EventBus } from '@/event-bus.js'

export default {
  name: 'radio',
  props: {
    optionIndex: Number,
    optionLabel: String,
    optionStatus: Boolean,
    name: String,
    disabled: Boolean
  },
  computed: {
    _optionStatus: function() {
      return this.optionStatus
    },
    _optionLabel: function() {
      return this.optionName
    },
    _optionIndex: function() {
      return this.optionIndex
    }
  },
  methods: {
    chooseRadio: function() {
      EventBus.$emit('chooseRadio', {
        'idx': this._optionIndex,
        'status': !this._optionStatus
      })
    }
  }
}
</script>

<style lang='scss'>
@import "~@/assets/sass/_variables.scss";
@import "~@/assets/sass/_form_fields.scss";

input[type=radio] {
  @include form-field;
  position: relative;
  margin: 0 0.2rem 0 0;
  padding: 0;
  text-align: center;
  width: .95rem;
  height: .95rem;
  background: white;
  -webkit-appearance: none;
  -webkit-border-radius: 0;
  border-radius: 50%;
  color: rgba(white, 0);
  transition: all 0.2s ease;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  vertical-align: text-top;

  &:before {
    font-family: FontAwesome;
    content: "\f111";
    font-size: .7rem;
    opacity: 0;
    position: absolute;
    left: 1px;
    right: 0;
    top: 0;
    bottom: 0;
  }
  &:focus {
    outline: 0;
  }
  &:active {
    outline: none;
  }
  &:hover {
    outline: none;
    cursor: pointer;
  }
  &:checked {
    color: $border;
    &:before {
      opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// radio.vue?23ee2450